import React, {
  type Dispatch,
  type FC,
  type ReactNode,
  type SetStateAction,
  useCallback,
  useState,
} from "react";

export interface NestContextValue {
  partnerCode: string | null;
  setPartnerCode: Dispatch<SetStateAction<string | null>>;
}

const DEFAULT_NEST_CONTEXT: NestContextValue = {
  partnerCode: null,
  setPartnerCode: () => {},
};

export const NestContext =
  React.createContext<NestContextValue>(DEFAULT_NEST_CONTEXT);

export const useNest = () => React.useContext(NestContext);

export const NestContextProvider: FC<{ children?: ReactNode }> = ({
  children,
}) => {
  const [partnerCode, setPartnerCode] = useState<string | null>(null);

  const getContextValue = useCallback(
    () => ({
      partnerCode,
      setPartnerCode,
    }),
    [partnerCode, setPartnerCode]
  );

  return (
    <NestContext.Provider value={getContextValue()}>
      {children}
    </NestContext.Provider>
  );
};
